import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/layout/AppLayout";

import LoginPage from "@/pages/LoginPage";
import RegisterShopPage from "@/pages/RegisterShopPage";
import DashboardPage from "@/pages/DashboardPage";
import PlatformTenantsPage from "@/pages/PlatformTenantsPage";
import TeamPage from "@/pages/TeamPage";
import NotificationsPage from "@/pages/NotificationsPage";
import ShowroomsPage from "@/pages/ShowroomsPage";
import CataloguesPage from "@/pages/CataloguesPage";
import CatalogueDetailPage from "@/pages/CatalogueDetailPage";
import CatalogueImportPage from "@/pages/CatalogueImportPage";
import CustomersPage from "@/pages/CustomersPage";
import CustomerDetailPage from "@/pages/CustomerDetailPage";
import ProjectsPage from "@/pages/ProjectsPage";
import ProjectDetailPage from "@/pages/ProjectDetailPage";
import WindowWorkspacePage from "@/pages/WindowWorkspacePage";
import QuotationsPage from "@/pages/QuotationsPage";
import QuotationDetailPage from "@/pages/QuotationDetailPage";
import PublicQuotePage from "@/pages/PublicQuotePage";
import ShopVerificationPage from "@/pages/ShopVerificationPage";
import EnquiriesPage from "@/pages/EnquiriesPage";
import ProductsPage from "@/pages/ProductsPage";
import ProductDetailPage from "@/pages/ProductDetailPage";

function RootRedirect() {
  const { user } = useAuth();
  return <Navigate to={user ? "/dashboard" : "/login"} replace />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" />
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterShopPage />} />
          <Route path="/quote/:token" element={<PublicQuotePage />} />

          <Route element={<ProtectedRoute />}>
            <Route element={<AppLayout />}>
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/notifications" element={<NotificationsPage />} />
              <Route path="/platform" element={<PlatformTenantsPage />} />
              <Route path="/shop-verification" element={<ShopVerificationPage />} />
              <Route path="/team" element={<TeamPage />} />
              <Route path="/showrooms" element={<ShowroomsPage />} />
              <Route path="/catalogues" element={<CataloguesPage />} />
              <Route path="/catalogues/imports/:importId" element={<CatalogueImportPage />} />
              <Route path="/catalogues/:catalogueId" element={<CatalogueDetailPage />} />
              <Route path="/products" element={<ProductsPage />} />
              <Route path="/products/:productId" element={<ProductDetailPage />} />
              <Route path="/customers" element={<CustomersPage />} />
              <Route path="/customers/:customerId" element={<CustomerDetailPage />} />
              <Route path="/enquiries" element={<EnquiriesPage />} />
              <Route path="/projects" element={<ProjectsPage />} />
              <Route path="/projects/:projectId" element={<ProjectDetailPage />} />
              <Route path="/windows/:windowId" element={<WindowWorkspacePage />} />
              <Route path="/quotations" element={<QuotationsPage />} />
              <Route path="/quotations/:quotationId" element={<QuotationDetailPage />} />
            </Route>
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
